<ion-header>
  <ion-toolbar color="primary">
    <ion-buttons slot="start">
      @if (isModal) {
        <ion-button (click)="modalController.dismiss()">{{ 'core.done' | translate }}</ion-button>
      } @else {
        <ion-back-button defaultHref="/employee-search" [text]="'core.backButton' | translate"></ion-back-button>
      }
    </ion-buttons>
    <ion-title>{{ employee.displayName }}</ion-title>
    <ion-buttons slot="end">
      <ion-button slot="icon-only" (click)="addToContacts()">
        <ion-icon name="person-add" aria-labelledby="add-to-contacts-label"></ion-icon>
        <span id="add-to-contacts-label" style="display:none">{{ 'employee-search.addToAddressbook' | translate}}</span>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>

<ion-content>
  <div class="flex ion-justify-content-center">
    <ion-thumbnail>
      <img [src]="avatar" />
    </ion-thumbnail>
  </div>

  <ion-list>
    <ion-list-header>
      <ion-label>
        <ion-icon name="briefcase" slot="start" aria-hidden="true"></ion-icon>
        {{ 'employee-search.coreData' | translate }}
      </ion-label>
    </ion-list-header>
    <ion-item>
      <ion-icon name="at" slot="start" aria-hidden="true"></ion-icon>
      <ion-label>
        <h3>
          {{ 'employee-search.email' | translate }}
        </h3>
        <h2>
          <a [href]="'mailto:' + employee.email">{{ employee.email }}</a>
        </h2>
      </ion-label>
    </ion-item>
  </ion-list>

  @for (organization of organizationNumbers | keyvalue; track organization) {
    <ion-list>
      <ion-list-header>
        <ion-label>
          <ion-icon name="briefcase" slot="start" aria-hidden="true"></ion-icon>
          @if (organization.key !== 'other') {
            <span>
              {{ organization.key }}
            </span>
          }
          @if (organization.key === 'other') {
            <span>
              {{ 'employee-search.additionalNumber' | translate }}
            </span>
          }
        </ion-label>
      </ion-list-header>
      @for (number of organization.value; track number) {
        <ion-item>
          @if (number.type === 'ext') {
            <ion-icon name="call" slot="start" aria-hidden="true"></ion-icon>
          }
          @if (number.type === 'fax') {
            <ion-icon name="print" slot="start" aria-hidden="true"></ion-icon>
          }
          @if (number.type === 'sek') {
            <ion-icon name="home" slot="start" aria-hidden="true"></ion-icon>
          }
          <ion-label>
            <h3>
              @if (number.type === 'ext') {
                <span>{{ 'employee-search.telephone' | translate }}</span>
              }
              @if (number.type === 'fax') {
                <span>{{ 'employee-search.facsimile' | translate }}</span>
              }
              @if (number.type === 'sek') {
                <span>{{ 'employee-search.administration' | translate }}</span>
              }
            </h3>
            <h2>
              <span [innerHTML]="number.e164Num | phonenumber"></span>
            </h2>
            @if (number.street && number.roomName) {
              <h4>
                {{ number.street }}, Raum {{ number.roomName }}
              </h4>
            }
          </ion-label>
        </ion-item>
      }
    </ion-list>
  }

  @if (organizations && organizations.length > 0) {
    <ion-list>
      <ion-list-header>
        <ion-label>
          <ion-icon name="briefcase" slot="start" aria-hidden="true"></ion-icon>
          {{ 'employee-search.orgUnit' | translate }}
        </ion-label>
      </ion-list-header>
      @for (ou of organizations; track ou) {
        <ion-item>
          <ion-label class="ion-text-wrap">
            @if (ou.departmentDescription !== ou.description) {
              <h2>{{ ou.departmentDescription }}</h2>
            }
            <h3>{{ ou.description }}</h3>
          </ion-label>
        </ion-item>
      }
    </ion-list>
  }

  @if (employee.employeeExtension && employee.employeeExtension.addons && employee.employeeExtension.addons.length) {
    <ion-list>
      <ion-list-header>
        <ion-label>
          <ion-icon name="contact" slot="start" aria-hidden="true"></ion-icon>
          {{ 'employee-search.additionalContactOptions' | translate }}
        </ion-label>
      </ion-list-header>
      @for (addon of employee.employeeExtension.addons; track addon) {
        <span>
          @if (addon.type === 'HOMEPAGE') {
            <ion-item (click)="openURL(addon.value)" detail="true">
              <ion-icon name="link" slot="start" aria-hidden="true"></ion-icon>
              <ion-label class="ion-text-wrap">
                <h3>
                  {{ "employee-search.homepage" | translate }} {{ addon.label }}
                </h3>
                <h3 [innerHTML]="addon.value"></h3>
              </ion-label>
            </ion-item>
          } @else {
            <ion-item>
              @if (addon.type === 'MOBILE') {
                <ion-icon name="phone-portrait" slot="start" aria-hidden="true"></ion-icon>
              }
              @if (addon.type === 'SKYPE') {
                <ion-icon name="logo-skype" slot="start" aria-hidden="true"></ion-icon>
              }
              @if (addon.type === 'CUSTOM') {
                <ion-icon name="chatbubbles" slot="start" aria-hidden="true"></ion-icon>
              }
              <ion-label>
                <h3>
                  @if (addon.type === 'SKYPE') {
                    <span>{{ "employee-search.skype" | translate }}</span>
                  }
                  @if (addon.type === 'MOBILE') {
                    <span>{{ "employee-search.mobile" | translate }}</span>
                  }
                  {{ addon.label }}
                </h3>
                <h2 [innerHTML]="addon.value"></h2>
              </ion-label>
            </ion-item>
          }
        </span>
      }
    </ion-list>
  }

  @if (employee.employeeExtension && (employee.employeeExtension.descriptionDe || employee.employeeExtension.descriptionEn)) {
    <ion-list>
      <ion-list-header>
        <ion-label>
          <ion-icon name="contact" slot="start" aria-hidden="true"></ion-icon>
          {{ 'employee-search.description' | translate }}
        </ion-label>
      </ion-list-header>
      <ion-item lines="none">
        <ion-label class="ion-text-wrap">
          @if (translate.currentLang() === 'de-DE') {
            <p class="description" [innerHTML]="employee.employeeExtension.descriptionDe"></p>
          }
          @if (translate.currentLang() === 'en-US') {
            <p class="description" [innerHTML]="employee.employeeExtension.descriptionEn"></p>
          }
        </ion-label>
      </ion-item>
    </ion-list>
  }
</ion-content>
